import React, { Component } from "react";
import PropTypes from "prop-types";
import { StorageHandler } from "C4";
import { storageKeys, baseAppId } from "settings";

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
      size: {
        width: 0,
        height: 0,
      },
    };
  }

  componentDidMount() {
    this.loadBgImage();
  }

  async loadBgImage() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        image: appInfo.backgroundImage,
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        },
      });
    }
  }

  render() {
    const { image, size } = this.state;
    const { blur, darken, src } = this.props;

    let imgixUrl = `https://front.travpromobile.com/${baseAppId}/bg@2x.jpg`;
    if (image) {
      imgixUrl = `${imgixUrl.replace(
        "front.travpromobile.com",
        "travprocdn.imgix.net"
      )}`;
    }

    if (src) {
      imgixUrl = `${src.replace(
        "front.travpromobile.com",
        "travprocdn.imgix.net"
      )}?w=${size.width + 200}&h=${
        size.height
      }&crop=entropy,top,right&fit=crop`;
    }

    return (
      <div className="bgImage">
        {image && (
          <div
            style={{ backgroundImage: `url("${imgixUrl}")` }}
            className={`backgroundImage ${blur && "blur"} ${
              darken && "darken"
            }`}
          />
        )}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
  src: PropTypes.string,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
  src: "",
};
